import { useState } from "react";
import LOGO_URL from "assets/img/Billbergia-logo.webp";
import toast from "react-hot-toast";
import { httpsCallable } from "firebase/functions";
import { functions } from "config/firebase.config";
import { Link } from "react-router-dom";

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handlePasswordReset = async (e) => {
        e.preventDefault();
        if (!email) {
            setError("Please enter your email address first.");
            return;
        }
        try {
            setLoading(true);
            await sendPasswordResetEmail(email);
            toast.success("Password reset email sent! Please check your inbox.");
        } catch (error) {
            setLoading(false);
            console.error("Password reset error:", error);
            setError("Could not send password reset email. Please check the address is correct.");
        } finally {
            setLoading(false);
            setEmail('');
        }
    };

    const sendPasswordResetEmail = async (email) => {
        const callsendResetPassword = httpsCallable(functions, 'sendResetPasswordEmail');
        try {
            await callsendResetPassword({ email: email });
        } catch (error) {
            console.error("Email sending error:", error);
        }
    }

    return (
        <div className="min-h-screen bg-gray-100 flex flex-col justify-center items-center p-4">
            <div className="w-full max-w-md mx-auto">
                <img src={LOGO_URL} alt="Billbergia Logo" className="h-16 mx-auto mb-8" />
                <div className="bg-white rounded-xl shadow-md p-8">
                    <h1 className="text-2xl font-bold text-center text-gray-800 mb-6">Forgot Password</h1>
                    <form onSubmit={handlePasswordReset} className="space-y-6">
                        <input
                            type="email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            placeholder="Email Address"
                            className="w-full p-3 border rounded-md"
                            required
                        />
                        {error && <p className="text-red-500 text-sm">{error}</p>}
                        <button type="submit" disabled={loading} className="w-full p-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-blue-300">
                            {loading ? 'Sending...' : 'Send Email'}
                        </button>
                    </form>
                    <div className="text-center mt-4">
                        <Link to="/sign-in" className="text-sm text-blue-600 hover:underline">
                            Already Signed In?
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ForgotPassword;